import { useEffect, useState } from "react"
import { arrowLeft, logo, unView, view } from "../assets/images/images"
import CheckInput from "../assets/images/CheckInput"
import { useLocation, useNavigate } from "react-router-dom";
import { validateEmail, validatePassword } from "../share/validation";
import { checkEmailAccountant, resetPasword, resetPaswordConfirm } from "../services/api/auth.service";
import { publish } from "../services/loadingServices/loading.service";
import { showApiError } from "../services/apiError";

const LoginAccountant = () => {
    const nav = useNavigate();
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const token: any = useLocation().pathname.split("/").pop();
    const handleSubmitStepOne = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        publish('loading', true);
        const payload: any = {
            token: token
        }
        try {
            const response = await checkEmailAccountant(payload);
            if (response.data.success) {
                publish('loading', false);
                setShowSuccessPopup(true);
            }
        } catch (error: any) {
            publish('loading', false);
            showApiError(error, { language: window.languageContext?.language });
        }
    }

    return (
        <>
            <div className="py-10 space-y-10 xl:w-[550px]  mx-auto">
                <img src={logo} className="" />
                <form className="w-full space-y-8" onSubmit={(e: any) => handleSubmitStepOne(e)}>
                    <div className="space-y-4">
                        <p className="text-[24px] text-main font-bold">Join Company With Accountant</p>
                    </div>
                    <button className={`w-full h-10 text-base font-bold flex items-center justify-center rounded-md bg-[#3ABFC3]`}>
                        Join Company
                    </button>
                    <div className="flex items-center justify-center gap-x-3 text-base font-bold cursor-pointer" onClick={() => { nav("/login") }}>
                        <img src={arrowLeft} />
                        <p className="cursor-pointer text-main" >Back to Sign In</p>
                    </div>
                </form>

            </div>
            {
                showSuccessPopup && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-4">
                            <h2 className="text-2xl font-bold text-main mb-4">Success!</h2>
                            <p className="text-main mb-6">Your account has been joined successfully.</p>
                            <button
                                onClick={() => nav('/login')}
                                className="w-full bg-[#3ABFC3] text-main font-bold py-3 rounded-md"
                            >
                                Continue to Sign in
                            </button>
                        </div>
                    </div>
                )
            }
        </>
    )
}
export default LoginAccountant